import React, { useState } from "react";
import { Button, Container, Typography, Box, CircularProgress } from "@mui/material";
import { downloadTestPdf, downloadTestWord } from "../../services/budgets/DocumentTestService";

const DocumentTestPage = () => {
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [loadingWord, setLoadingWord] = useState(false);

  const handleDownload = async (type, downloadFn, filename, mimeType) => {
    const setLoading = type === "pdf" ? setLoadingPdf : setLoadingWord;
    setLoading(true);
    try {
      const blob = await downloadFn();
      const url = window.URL.createObjectURL(new Blob([blob], { type: mimeType }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(`Erro ao gerar ${type.toUpperCase()}:`, error);
      alert(`Erro ao gerar ${type.toUpperCase()}. Ver consola para detalhes.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8, textAlign: "center" }}>
      <Typography variant="h4" gutterBottom>
        Página de Teste — Geração de Documentos
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Clique nos botões abaixo para gerar e descarregar os ficheiros de teste.
      </Typography>

      <Box sx={{ display: "flex", gap: 3, justifyContent: "center" }}>
        <Button
          variant="contained"
          color="error"
          size="large"
          disabled={loadingPdf}
          onClick={() =>
            handleDownload("pdf", downloadTestPdf, "general_info.pdf", "application/pdf")
          }
        >
          {loadingPdf ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Gerar PDF"}
        </Button>

        <Button
          variant="contained"
          color="primary"
          size="large"
          disabled={loadingWord}
          onClick={() =>
            handleDownload(
              "word",
              downloadTestWord,
              "test_budget.docx",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            )
          }
        >
          {loadingWord ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Gerar Word"}
        </Button>
      </Box>
    </Container>
  );
};

export default DocumentTestPage;
